import { useContext } from 'react';
import { TicketingSystemActionsContext, TicketingSystemStateSelectorsContext } from './TicketingSystemProvider';

export const useTicketingSystemStateSelectorsContext = () =>
    useContext(TicketingSystemStateSelectorsContext);

export const useTicketingSystemActionsContext = () =>
    useContext(TicketingSystemActionsContext);
